<template>
  <div class="back-index" @click.stop="toIndex">
    <img src="../../assets/icons/back_home.png" alt="">
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import storage from 'storejs'
import { Dialog} from 'vant'
export default {
methods: {
  ...mapMutations({
    setAuthorizeBeforePath: "setAuthorizeBeforePath"
  }),
  toIndex(){
        if (
        !storage.get(process.env.STORAGE_NAME) ||
        (storage.get(process.env.STORAGE_NAME) &&
          !storage.get(process.env.STORAGE_NAME).encrypt)
      ){
        Dialog.confirm({
          title: '提示',
          message: '未登录无法进行此操作！',
          confirmButtonText: '去登录',
          cancelButtonText: '再看看',
          showCancelButton: true,
        }).then(() => {
          // on confirm
          this.setAuthorizeBeforePath(this.$route.fullPath);
          this.$router.push({
            path: '/login',
          });
        }).catch(() => {
          // on cancel
        });
        return;
      }
    this.$router.push({
      path:'/'
    })
  }
},
}
</script>

<style lang='less' scoped>
.back-index {
  width:0.5rem;
  height:0.5rem;
  position: fixed;
  right: 14px;
  bottom: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/backIndex.vue